module.exports = __webpack_public_path__ + "static/media/Instagram.4f150610.svg";